import { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ForumIcon from '@mui/icons-material/Forum';
import { colors } from 'styles/colors';
import { hexWithOpacity } from 'common/utils';
import DiscussionNotesModal from 'components/modals/DiscussionNotesModal/DiscussionNotesModal';

interface Props {
  id: number;
  hasNotes?: boolean;
  refetch?: () => void;
}

export default function DiscussionNotesButton({ id, hasNotes, refetch }: Props) {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    refetch?.();
  };

  return (
    <>
      <Tooltip title="Notes">
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            setOpen(true);
          }}
          sx={{
            width: 25,
            height: 25,
            backgroundColor: hasNotes ? colors.notes : hexWithOpacity(colors.primary, 0.5),
            borderRadius: '4px',
            padding: 0,
            '&:hover': {
              backgroundColor: hasNotes ? colors.notes : hexWithOpacity(colors.primary, 0.5),
            },
          }}
        >
          <ForumIcon sx={{ fontSize: 12, color: 'white' }} />
        </IconButton>
      </Tooltip>

      <DiscussionNotesModal
        open={open}
        onClose={handleClose}
        procedureId={id}
      />
    </>
  );
}
